module.exports = __webpack_public_path__ + "static/image-04@2x-396f7dc292945410119c0e3c52840466.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/designmuseum/image-04@2x.jpg
// module id = 371
// module chunks = 3627797113349 20562973939449 33019919093843